import { ContractAddress } from 'constants/ContractAddress';
import { IBidToken } from 'models/NFTDetails';

export const DEMO_WALLET_COLLECTOR = '0xDemoCollector1111111111111111111111111111';
export const DEMO_WALLET_TRADER = '0xDemoTrader222222222222222222222222222222';

export const MOCK_BID_TOKEN: IBidToken = {
  address: ContractAddress.HRC20,
  decimals: 18,
  name: 'MAGIC',
  symbol: 'MAGIC',
};

export const MOCK_HRC721 = ContractAddress.HRC721;
export const MOCK_HRC1155 = ContractAddress.HRC1155;

export const toTokenAmount = (amount: number): string =>
  BigInt(Math.floor(amount * 1e18)).toString();

export const demoImage = (seed: string | number): string =>
  `https://picsum.photos/seed/cosmic-${seed}/400/400`;

export const futureDate = (daysFromNow: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return date.toISOString();
};

export const pastDate = (daysAgo: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return date.toISOString();
};
